import axios from "axios";
import BundleOrderLine from "./BundleOrderLine";

const OrderService = function () {
  this.orderController = "/Umbraco/Api/Order/";
};

OrderService.prototype = {
  addOrUpdateOrderLines: function (bundleOrderLines) {
    return new Promise((resolve, reject) => {
      const res = axios({
        method: "post",
        url: `${this.orderController}/AddOrUpdateOrderLines`,
        data: JSON.stringify(bundleOrderLines),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      resolve(res);
    });
  },
  addOrUpdateOrderLineById: function (id, qty, overwriteQuantity) {
    return new Promise((resolve, reject) => {
      const res = axios({
        method: "post",
        url: `${this.orderController}/AddOrUpdateOrderLineById`,
        data: {
          Id: id,
          OverwriteQuantity: overwriteQuantity,
          Quantity: qty
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
      resolve(res);
    });
  },
  addOrUpdateOrderLineQuantityById: function (id, currentQty, minQty, stepQty) {
    const mQty = minQty > 0 ? minQty : 0;
    const stQty = stepQty > 0 ? stepQty : 1;

    if (currentQty < mQty) {
      const qty = mQty > 0 ? mQty : stQty;
      return this.addOrUpdateOrderLineById(id, qty, true);
    }

    let diffToNext = (currentQty - mQty) % stQty;
    if (diffToNext === 0) diffToNext = stQty - diffToNext;

    return this.addOrUpdateOrderLineById(id, diffToNext, false);
  },
  minueOrderLineQuantityById: function (id, currentQty, minQty, stepQty) {
    const mQty = minQty > 0 ? minQty : 0;
    const stQty = stepQty > 0 ? stepQty : 1;

    if (currentQty <= mQty) {
      return this.addOrUpdateOrderLineById(id, 0, true);
    }

    let diffToNext = -(currentQty - mQty) % stQty;
    if (diffToNext === 0) diffToNext = -stQty;

    return this.addOrUpdateOrderLineById(id, diffToNext, false);
  },
  deleteOrderline: function (id) {
    return new Promise((resolve, reject) => {
      const res = axios({
        method: "post",
        url: `${this.orderController}/RemoveOrderLine`,
        data: {
          Id: id,
          Quantity: 0
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
      resolve(res);
    });
  }
};

export { OrderService, BundleOrderLine };



// WEBPACK FOOTER //
// ./EcomCore/Models/Order/OrderService.js